//include 11
jQuery(function () {
    var distanceAirportLabel = window.ppt.translate("distances.airport", "Flughafen BER – Berlin Brandenburg");
    //var distanceAirportTegelLabel = window.ppt.translate("distances.airport.tegen", "Flughafen Berlin-Tegel");
    var distanceBerlinCenterLabel = window.ppt.translate("distances.berlinmitte", "Berlin-Mitte");
    var distanceFreewayLabel = window.ppt.translate("distances.freeway", "Autobahnanschluss");
    var distanceStationLabel = window.ppt.translate("distances.station", "Nächster Bahnhof");
    var placeholderText = window.ppt.translate("distances.placeholder", "Entfernung");
    var placeholderFilledText = window.ppt.translate("distances.placeholder.filled", "Entfernung eingegeben");

    var privateFunctions = {
        checkAndSetPosition(selector) {
            selector.css({
                top: "",
                left: ""
            });

            var overflows = window.pixelpoint.utilities.getOverflows(selector);
            var offset = 0;
            if (overflows.left > 0) {
                offset = selector.offset(); //always need to update
                selector.offset({
                    top: offset.top,
                    left: offset.left + overflows.left
                });
            } else if (overflows.right > 0) {
                offset = selector.offset();
                selector.offset({
                    top: offset.top,
                    left: offset.left - overflows.right
                });
            }
            if (overflows.top > 0) {
                offset = selector.offset();
                selector.offset({
                    top: offset.top + overflows.top,
                    left: offset.left
                });
            } else if (overflows.bottom > 0) {
                offset = selector.offset();
                selector.offset({
                    top: offset.top - overflows.bottom,
                    left: offset.left
                });
            }
        },
        parseInt(number) {
            var result = parseInt(number);
            if (isNaN(result)) return 0;
            return result;
        },
        getSelector(picker, selector) {
            var element = picker.find(selector);
            if (element.length == 0) {
                var pickerId = picker.attr("id");
                if (!!pickerId) {
                    element = $(`.distance-picker-layer#for-${pickerId}`).find(selector);
                }
            }
            return element;
        },
        getDistance(picker, name) {
            return privateFunctions.parseInt(
                privateFunctions
                    .getSelector(picker, `input[name='${name}']`)
                    .val()
            );
        },
        getAirportDistance(picker) {
            var inputName = picker.data("airport-input-name");
            return privateFunctions.getDistance(picker, inputName);
        },
        /*
        getAirportTegelDistance(picker) {
            var inputName = picker.data("airport-tegel-input-name");
            return privateFunctions.getDistance(picker, inputName);
        },
        //*/
        getBerlinMitteDistance(picker) {
            var inputName = picker.data("berlin-mitte-input-name");
            return privateFunctions.getDistance(picker, inputName);
        },
        getFreewayDistance(picker) {
            var inputName = picker.data("freeway-input-name");
            return privateFunctions.getDistance(picker, inputName);
        },
        getStationDistance(picker) {
            var inputName = picker.data("station-input-name");
            return privateFunctions.getDistance(picker, inputName);
        },
        getActiveDistance(picker){
            var inputName = picker.data("active-distance");
            var value = privateFunctions.getDistance(picker, inputName);
            return {
                name: inputName,
                value: value
            };
        },
        deactivateAll(picker){
            privateFunctions.getSelector(picker, `.selector-part`)
                .removeClass("selected")
                .find("input")
                .val("0")
                .prop("disabled",true);
        },
        setActiveDistance(picker, inputName){
            privateFunctions.deactivateAll(picker);

            privateFunctions
                .getSelector(picker, `input[data-input='${inputName}']`)
                .prop("disabled",false)
                .closest(".selector-part").addClass("selected");
            picker.data("active-distance", inputName);
            privateFunctions.update(picker);
        },
        get(picker) {
            //*
            var distanceAirport = privateFunctions.getAirportDistance(picker);
            //var distanceAirportTegel = privateFunctions.getAirportTegelDistance(picker);
            var distanceBerlinMitte = privateFunctions.getBerlinMitteDistance(picker);
            var distanceFreeway = privateFunctions.getFreewayDistance(picker);
            var distanceStation = privateFunctions.getStationDistance(picker);

            return {
                airport: distanceAirport,
                //airportTegel: distanceAirportTegel,
                berlinMitte: distanceBerlinMitte,
                freeway: distanceFreeway,
                station: distanceStation
            };
            //*/
            //return privateFunctions.getActiveDistance(picker);
        },

        setDistance(picker, name, val) {
            if (val < 0) {
                val = 0;
            }
            if (val > 10) {
                val = 10;
            }
            privateFunctions
                .getSelector(picker, `input[data-input='${name}']`)
                .val(val);
        },
        setAirportDistance(picker, val) {
            var inputName = picker.data("airport-input-name");
            return privateFunctions.setDistance(picker, inputName, val);
        },
        /*
        setAirportTegelDistance(picker, val) {
            var inputName = picker.data("airport-tegel-input-name");
            return privateFunctions.setDistance(picker, inputName, val);
        },
         */
        setBerlinMitteDistance(picker, val) {
            var inputName = picker.data("berlin-mitte-input-name");
            return privateFunctions.setDistance(picker, inputName, val);
        },
        setFreewayDistance(picker, val) {
            var inputName = picker.data("freeway-input-name");
            return privateFunctions.setDistance(picker, inputName, val);
        },
        setStationDistance(picker, val) {
            var inputName = picker.data("station-input-name");
            return privateFunctions.setDistance(picker, inputName, val);
        },
        isCleared(picker) {
            var distanceAirport = privateFunctions.getAirportDistance(picker);
            //var distanceAirportTegel = privateFunctions.getAirportTegelDistance(picker);
            var distanceBerlinMitte = privateFunctions.getBerlinMitteDistance(picker);
            var distanceFreeway = privateFunctions.getFreewayDistance(picker);
            var distanceStation = privateFunctions.getStationDistance(picker);

            return (distanceAirport === "" &&
                // distanceAirportTegel === "" &&
                distanceBerlinMitte === "" &&
                distanceFreeway === "" &&
                distanceStation === "");
        },
        toggleDisable(disableOrEnable, picker) {
            if (!!disableOrEnable) {
                privateFunctions.getSelector(picker, "input").prop("disabled", true);
                picker.data("is-disabled", true);
                picker.removeClass("active");
            } else {
                privateFunctions.getSelector(picker, "input").prop("disabled", false);
                picker.data("is-disabled", false);
            }
        },
        validate(picker, showErrors, forceOpen) {
            var valid = true;
            if (picker.data("is-disabled") == true) {
                return valid;
            }
            picker.removeClass("invalid");
            $(`.distance-picker-layer`).removeClass("invalid");

            showErrors = showErrors || false;
            forceOpen = forceOpen || false;

            var distanceAirport = privateFunctions.getAirportDistance(picker);
            //var distanceAirportTegel = privateFunctions.getAirportTegelDistance(picker);
            var distanceBerlinMitte = privateFunctions.getBerlinMitteDistance(picker);
            var distanceFreeway = privateFunctions.getFreewayDistance(picker);
            var distanceStation = privateFunctions.getStationDistance(picker);
            if (
                isNaN(distanceAirport) ||
                //isNaN(distanceAirportTegel) ||
                isNaN(distanceBerlinMitte) ||
                isNaN(distanceFreeway) ||
                isNaN(distanceStation)
            ) {
                valid = false;
                if (showErrors) {
                    picker.addClass("invalid");
                    if (forceOpen) picker.addClass("active");

                    if ($(`.distance-picker-layer`).length > 0) {
                        var pickerId = picker.attr("id");
                        if (!!pickerId) {
                            $(`.distance-picker-layer#for-${pickerId}`).addClass("invalid");
                        }
                    }
                }
            }
            return valid;
        },
        clear($this) {
            privateFunctions.setAirportDistance($this, "");
            //privateFunctions.setAirportTegelDistance($this, "");
            privateFunctions.setBerlinMitteDistance($this, "");
            privateFunctions.setFreewayDistance($this, "");
            privateFunctions.setStationDistance($this, "");


        },

        update($this){
            var placeholder = $this.data("placeholder") || placeholderText;
            var placeholderFilled = $this.data("placeholder-filled") || placeholderFilledText;
            var data = privateFunctions.get($this);
            var isEmpty = true;
            for(var i in data){
                if(data[i] > 0){
                    isEmpty = false;
                }
            }
            if(isEmpty){
                $this.find(">span").text(placeholder);
            }
            else{
                $this.find(">span").text(placeholderFilled);
            }
        },

        init($this) {

            var distanceAirportInputName = $this.data("airport-input-name") || "airport";
            //var distanceAirportTegelInputName = $this.data("airport-tegel-input-name") || "airportTegel";
            var distanceBerlinMitteInputName = $this.data("berlin-mitte-input-name") || "berlinMitte";
            var distanceFreewayInputName = $this.data("freeway-input-name") || "freeway";
            var distanceStationInputName = $this.data("station-input-name") || "station";

            $this.data("airport-input-name", distanceAirportInputName);
            //$this.data("airport-tegel-input-name", distanceAirportTegelInputName);
            $this.data("berlin-mitte-input-name", distanceBerlinMitteInputName);
            $this.data("freeway-input-name", distanceFreewayInputName);
            $this.data("station-input-name", distanceStationInputName);

            var maxDistanceAirport = $this.data("max-airport-input") || 9999;
            //var maxDistanceAirportTegel = $this.data("max-airport-tegel-input") || 9999;
            var maxDistanceBerlinMitte = $this.data("max-berlin-mitte-input") || 9999;
            var maxDistanceFreeway = $this.data("max-freeway-input") || 9999;
            var maxDistanceStation = $this.data("max-station-input") || 9999;

            var initialDistanceAirport = $this.data("initial-airport-value") || 0;
            //var initialDistanceAirportTegel = $this.data("initial-airport-tegel-value") || 0;
            var initialDistanceBerlinMitte = $this.data("initial-berlin-mitte-value") || 0;
            var initialDistanceFreeway = $this.data("initial-freeway-value") || 0;
            var initialDistanceStation = $this.data("initial-station-value") || 0;

            var eventsPostfix = $this.data("events-postfix") || null;
            var disabled = $this.is("[data-disabled]");
            var placeholder = $this.data("placeholder") || placeholderText;
            var placeholderFilled = $this.data("placeholder-filled") || placeholderFilledText;

            var elementId = $this.attr("id");
            if (!elementId) {
                elementId = Math.random()
                    .toString(36)
                    .substring(5);
                $this.attr("id", elementId);
            }

            if (maxDistanceAirport > -1 && initialDistanceAirport > maxDistanceAirport)
                initialDistanceAirport = maxDistanceAirport;
            /*
            if (maxDistanceAirportTegel > -1 && initialDistanceAirportTegel > maxDistanceAirportTegel)
                initialDistanceAirportTegel = maxDistanceAirportTegel;
             */
            if (maxDistanceBerlinMitte > -1 && initialDistanceBerlinMitte > maxDistanceBerlinMitte)
                initialDistanceBerlinMitte = maxDistanceBerlinMitte;
            if (maxDistanceFreeway > -1 && initialDistanceFreeway > maxDistanceFreeway)
                initialDistanceFreeway = maxDistanceFreeway;
            if (maxDistanceStation > -1 && initialDistanceStation > maxDistanceStation)
                initialDistanceStation = maxDistanceStation;

            var closeTitle = $this.data("close-title");
            var removeTitle = $this.data("remove-title");

            var layerClasses = $this.data("layer-classes") || "";
            var labelClasses = $this.data("label-classes") || "columns small-7";
            var inputClasses = $this.data("input-classes") || "columns small-5";

            var usedPlaceholder = placeholder;
            if(
                !!initialDistanceStation ||
                !!initialDistanceFreeway ||
                initialDistanceBerlinMitte ||
               // initialDistanceAirportTegel ||
                initialDistanceAirport
            ){
                usedPlaceholder = placeholderFilled;
            }
            $this.html(`
                <input type="hidden" name="${distanceAirportInputName}" value="${initialDistanceAirport}" />
                
                <input type="hidden" name="${distanceBerlinMitteInputName}" value="${initialDistanceBerlinMitte}" />
                <input type="hidden" name="${distanceFreewayInputName}" value="${initialDistanceFreeway}" />
                <input type="hidden" name="${distanceStationInputName}" value="${initialDistanceStation}" />
                <span>${usedPlaceholder}</span>
                <button class="clear">
                    <i class="icon-close" title="${removeTitle}"></i>
                </button>
                <div class="selector ${layerClasses}">
                    <div class="selector-part row">
                        <!-- <i>&#10004;</i> -->
                        <div class="${labelClasses}">${distanceAirportLabel}</div>
                        <div class="${inputClasses}">
                            <input type="number" min="0" max="${maxDistanceAirport}" data-input="${distanceAirportInputName}" value="${initialDistanceAirport}" />
                            <span>km</span>
                        </div>                        
                    </div>
                    <div class="selector-part row">
                        <!-- <i>&#10004;</i> -->
                        <div class="${labelClasses}">${distanceBerlinCenterLabel}</div>
                        <div class="${inputClasses}">
                            <input type="number" min="0" max="${maxDistanceBerlinMitte}" data-input="${distanceBerlinMitteInputName}" value="${initialDistanceBerlinMitte}" />
                            <span>km</span>
                        </div>                        
                    </div>
                    <div class="selector-part row">
                        <!-- <i>&#10004;</i> -->
                        <div class="${labelClasses}">${distanceFreewayLabel}</div>
                        <div class="${inputClasses}">
                            <input type="number" min="0" max="${maxDistanceFreeway}" data-input="${distanceFreewayInputName}" value="${initialDistanceFreeway}" />
                            <span>km</span>
                        </div>                        
                    </div>
                    <div class="selector-part row">
                        <!-- <i>&#10004;</i> -->
                        <div class="${labelClasses}">${distanceStationLabel}</div>
                        <div class="${inputClasses}">
                            <input type="number" min="0" max="${maxDistanceStation}" data-input="${distanceStationInputName}" value="${initialDistanceStation}" />
                            <span>km</span>
                        </div>                        
                    </div>
                    <button class="close-selector">
                        <i class="icon-close" title="${closeTitle}"></i>
                    </button>
                </div>                
            `);

            var selector = $this.find(".selector");
            selector.on("change", "input[type='number']", function(e){
                var inputToChange = $(this).data("input");
                if(!!inputToChange){
                    privateFunctions.getSelector($this, `input[name='${inputToChange}']`).val($(this).val());
                    privateFunctions.update($this);
                }
            });


            if ($("body").find(`.distance-picker-layer#for-${elementId}`).length == 0) {
                $("body").append(`<div id="for-${elementId}" class="distance-picker-layer hide ${layerClasses}"></div>`);
                $("body .distance-picker-layer").click(function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
            }

            var selectorIsGlobal = false;
            if (window.pixelpoint.isMobile.isMobileWidth()) {
                $(`body .distance-picker-layer#for-${elementId}`).append(selector);
                var saveTranslation = window.ppt.translate('save', 'Speichern');
                selector.append(`<a class="brandenbutton save-values">${saveTranslation}</a>`);
                selector.on("click touchstart", ".save-values", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (privateFunctions.validate($this, true)) {
                        $(`.distance-picker-layer#for-${elementId}`).addClass("hide");
                    }
                });
                selectorIsGlobal = true;
            }
            $this.addClass("initialized");
            
            var activatePicker = function(e) {
                e.preventDefault();
                if ($this.data("is-disabled") == true) {
                    return;
                }
                $this.addClass("active");

                if (selectorIsGlobal) {
                    $(`.distance-picker-layer#for-${elementId}`).removeClass("hide");
                } else {
                    privateFunctions.checkAndSetPosition($this.find(".selector"));
                }
            };
            $this.on("click", activatePicker); 
            $this.on("keydown", function (e) {
                if (e.key === "Enter" || e.keyCode === 13) {
                activatePicker(e);
                }
            });

            $this.on("click", ".clear", function (e) {
                e.preventDefault();
                privateFunctions.clear($this);
            });
            $(document).on("mouseup touchend", function (e) {
                if (!selector.is(e.target) && !$.contains(selector[0], e.target)) {
                    if (privateFunctions.validate($this, true)) {
                        $this.removeClass("active");
                        if (selectorIsGlobal) {
                            $(`.distance-picker-layer#for-${elementId}`).addClass("hide");
                        }
                    }
                }
            });

            var closePicker = function(e) {
                e.preventDefault();
                e.stopPropagation();
                $this.removeClass("active");
                if (selectorIsGlobal) {
                    $(`.distance-picker-layer#for-${elementId}`).addClass("hide");
                }
            };
            selector.find(".close-selector").on("click", closePicker);
            selector.find(".close-selector").on("keydown", function (e) {
                if (e.key === "Enter" || e.keyCode === 13) {
                closePicker(e);
                }
            });
            // Add ESC key listener specifically for this picker's selector
            selector.on("keydown", function (e) {
                if (e.key === "Escape" || e.keyCode === 27) {
                closePicker(e);
                }
            });

            var exposedFunctions = {
                set(data, supressEvent) {
                    privateFunctions.setAirportDistance($this, data.airport);
                    //privateFunctions.setAirportTegelDistance($this, data.airportTegel);
                    privateFunctions.setBerlinMitteDistance($this, data.berlinMitte);
                    privateFunctions.setFreewayDistance($this, data.freeway);
                    privateFunctions.setStationDistance($this, data.station);
                },
                get() {
                    return privateFunctions.get($this);
                },
                disable() {
                    privateFunctions.toggleDisable(true, $this);
                },
                enable() {
                    privateFunctions.toggleDisable(false, $this);
                },
                valid(forceOpen) {
                    return privateFunctions.validate($this, true, forceOpen);
                },
                reset() {
                    privateFunctions.clear($this);
                }
            };
            $this
                .data("form-element-functions", exposedFunctions)
                .attr("data-form-element-functions-added", true);
            if (!!disabled) {
                privateFunctions.toggleDisable(true, $this);
                $this.closest(".control").addClass("disabled");
            }

            // privateFunctions.setActiveDistance($this, distanceAirportInputName);
        }
    };
    window.pixelpoint.ppComponents.distancePicker = function ($this) {
        privateFunctions.init($this);
    };
    $(".distance-picker").each(function () {
        window.pixelpoint.ppComponents.distancePicker($(this));
    });
});